export default __webpack_public_path__ + "ced068e.png";